import { SubscriptionStatus } from '../MyAccountPage';

export const SUBSCRIPTION_STATUS = {
  expired: 'EXPIRED',
  canceled: 'CANCELED',
  active: 'ACTIVE',
};

export const SUBSCRIPTION = {
  annual: 'annual',
  seasonal: 'seasonal',
  trial: 'trial',
};

export const PLAN_CODE = {
  ffftrial: 'ffftrial',
  fffvip: 'fffvip',
  fffvipa: 'fffvipa',
};

export const getUserSubscriptionStatus = (subscriptionState: SubscriptionStatus) => {
  if (subscriptionState === 'ACTIVE') {
    return {
      SUBSCRIPTION_STATE: subscriptionState,
      COLOR: 'green',
    };
  }
  if (subscriptionState === 'EXPIRED') {
    return {
      SUBSCRIPTION_STATE: subscriptionState,
      COLOR: 'red',
    };
  }
  if (subscriptionState === 'CANCELED') {
    return {
      SUBSCRIPTION_STATE: subscriptionState,
      COLOR: 'grey',
    };
  }
  return {
    SUBSCRIPTION_STATE: subscriptionState,
    COLOR: 'green',
  };
};
